import { Link } from "react-router-dom";
import "../../assets/styles/components/Breadcum/Breadcrumbs.css";
import { ChevronRight } from "lucide-react";

const ProductDetailBreadcrumbs = ({ paths = [] }) => {

  // Remove empty/null labels
  const validPaths = paths;
  return (
    <nav className="breadcrumb-wrapper">
      <Link to="/" className="breadcrumb-item">Home</Link>

      {validPaths.map((item, index) => (
        <span key={index} className="breadcrumb-segment">
          <span className="breadcrumb-separator">
            <ChevronRight size={20} />
          </span>

          {item.to ? (
            <Link to={item.to} className="breadcrumb-item">
              {item.label}
            </Link>
          ) : (
            <span className="breadcrumb-item active">
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
};

export default ProductDetailBreadcrumbs;